export const PUT_SPHERE_SORT = '@@sphereSort/putSphereSort'

export const SAVE_SPHERE_SORT_MODEL = '@@sphereSort/saveSphereSortModel'

export const SAVE_SPHERE_SORT_FIELD = '@@sphereSort/saveSphereSortField'

export const SAVE_SPHERE_SORT_ORDER = '@@sphereSort/saveSphereSortOrder'
